import { Injectable } from "@angular/core";
import { firstValueFrom, of } from "rxjs";
import { catchError } from "rxjs/operators";
import { RestService } from "../rest/rest.service";
import { ConfigGlobalModel } from "app/models/config-global-model";
import { Log } from "app/core/logging/log";


@Injectable({ providedIn: 'root' })
export class ConfigService {
  private config: ConfigGlobalModel = {
    id: 0,
    name: 'MyLocker',
    domain: '',
    reserveDomain: '',
    color: '#ff8a00',
    logo: {
      imageSmall: '',
      imageMedium: '',
      imageLarge: ''
    },
    locations: []
  };

  constructor(private restService: RestService) { }

  loadConfig(): Promise<ConfigGlobalModel> {
    return firstValueFrom(
      this.restService.getConfigurations().pipe(
        catchError((error) => {
          Log.error('ConfigService.loadConfig fallback', { error });
          return of(this.config);
        })
      )
    ).then(data => this.config = data);
  }

  get settings():ConfigGlobalModel { return this.config; }
}
